export const payoutData = [
  {
    id: 0,
    storename: "ZephyrZest Clothing",
    username: "Arnold Armstrong",
    currency: "NGN",
    amount: "45,000",
    date: "04-03-2021 09:03:05AM",
    status: "Pending",
    accountName: "ZephyrZest Stores",
    accountNumber: "2192833930",
    bank: "UBA",
  },
  {
    id: 1,
    storename: "SereneScape Retreats",
    username: "Jean Douglas",
    currency: "USD",
    amount: "3,000",
    date: "21-06-2021 10:03:05AM",
    status: "Approved",
    accountName: "SereneScape Medicals",
    accountNumber: "2100033930",
    bank: "Zenith",
  },
];

export const filterCurrency = [
  { label: "USD", value: "USD" },
  { label: "NGN", value: "NGN" },
];

export const filterPayoutStatus = [
  { label: "Approved", value: "Approved" },
  { label: "Pending", value: "Pending" },
  { label: "Declined", value: "Declined" },
];
